import React, { useEffect, useState } from 'react';
import { getCachedSVG } from '../../utils/iconCache';

interface IInlineSVGProps {
  src: string  
  color?: string
  height?: string
  width?: string
  className?: string;
  iconClicked?: () => void
}

const InlineSVG = ( props: IInlineSVGProps ) => {
  const [svgHtml, setSvgHtml] = useState<string>('');

  useEffect(() => {
    const svgElement = getCachedSVG(props.src)
    svgElement.then((svg) => {
        if(svg){
            svg.removeAttribute('fill');
            svg.removeAttribute('width');
            svg.removeAttribute('height');
            svg.setAttribute('fill', props.color || "black");
            svg.setAttribute('width', props.width || "30px");
            svg.setAttribute('height', props.height || "30px");

            setSvgHtml(svg.outerHTML)
        } else {
            setSvgHtml('')
        }
    })
  }, [props]);

  return (
    <>
        {svgHtml !== '' ?
            <div
                style={{
                    width: props.width || "30px",
                    height: props.height || "30px",
                    display: "inline-block"
                }}
                className={props.className || ""}
                dangerouslySetInnerHTML={{ __html: svgHtml }}
                onClick={props.iconClicked}
            ></div>
        :
            <></>
        }
    </>
  );
};

export default InlineSVG;